export default "__VITE_ASSET__9b297eb2__"